export default __webpack_public_path__ + "static/media/logo.614d71d1.svg";